module.exports = __webpack_public_path__ + "img/versat_token.gr.a357973.png";